import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import MedioViaje, { useMedioViaje } from '../ui/MedioViaje';
import { formatFechaCorta as ddmm } from '../../utils/dateUtils';
import TabMes from './TabMes';
import TabEquipos from './TabEquipos';
import { LuMap } from 'react-icons/lu';

// Rentabilidad de un cliente con tarifa mensual (28-oct-2026). Antes era una sección aparte del menú
// (con un selector de cliente y los ajustes mezclados); ahora se abre desde la ficha del cliente, al lado
// del cierre mensual, y sirve para cualquier empresa con tarifa por volumen, no solo Modo Agua.
// Los ajustes (pasajes, tiempos, base) están en Finanzas → Ajustes.
// Los últimos 12 meses calendario, para comparar (el período en curso es lo que se le cobra a la empresa)
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function ultimosMeses() {
    const d = new Date(); d.setDate(1);
    return Array.from({ length: 12 }, () => {
        const m = { id: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, label: `${MESES[d.getMonth()]} ${d.getFullYear()}` };
        d.setMonth(d.getMonth() - 1);
        return m;
    });
}
const TABS = [{ id: 'mes', label: 'El período' }, { id: 'lugares', label: 'Dónde están' }];

export default function RentabilidadCliente({ cliente, onCerrar }) {
    const [tab, setTab] = useState('mes');
    // '' = el período en curso (29-oct-2026: a la empresa se le cobra por período, no por mes calendario)
    const [mes, setMes] = useState('');
    const [medio, setMedio] = useMedioViaje();
    const [datosMes, setDatosMes] = useState(null);
    const [datosEq, setDatosEq] = useState(null);
    const [error, setError] = useState(null);

    const cargar = useCallback(() => {
        setError(null); setDatosMes(null); setDatosEq(null);
        api.get(`/rentabilidad/${cliente.id}/mes`, { params: { ...(mes ? { mes } : {}), medio } }).then(r => setDatosMes(r.data))
            .catch(e => setError(e?.response?.data?.mensaje || 'No se pudo calcular'));
        api.get(`/rentabilidad/${cliente.id}/equipos`, { params: { medio } }).then(r => setDatosEq(r.data)).catch(() => {});
    }, [cliente.id, mes, medio]);
    useEffect(() => { cargar(); }, [cargar]);

    const irAlMapa = () => {
        try { sessionStorage.setItem('mapaAbrir', JSON.stringify({ vista: 'pendientes', filtro: `c-${cliente.id}` })); } catch { /* */ }
        onCerrar();
        window.dispatchEvent(new CustomEvent('ir-a-seccion', { detail: 'mapa' }));
    };
    const cargando = <div className="space-y-2">{[1, 2, 3].map(i => <div key={i} className="h-24 rounded-2xl bg-panel animate-pulse" />)}</div>;
    const control = 'h-10 px-3 rounded-xl text-label font-bold outline-none bg-chip text-ink';

    return (
        <ModalShell titulo={`Rentabilidad · ${cliente.nombre}`} subtitulo="¿Te deja plata? Lo que cobrás, lo que gastás en moverte y qué conviene"
            onCerrar={onCerrar} ancho="md:max-w-3xl">
            <div className="space-y-3">
                <div className="grid grid-cols-2 gap-1 p-1 rounded-xl bg-panel">
                    {TABS.map(t => (
                        <button key={t.id} type="button" onClick={() => setTab(t.id)} aria-pressed={tab === t.id}
                            className={`h-9 rounded-lg text-label font-black ${tab === t.id ? 'bg-ink text-page' : 'text-secondary'}`}>{t.label}</button>
                    ))}
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    {tab === 'mes' && (
                        <>
                            <button type="button" onClick={() => setMes('')} aria-pressed={!mes}
                                className={`h-10 px-3 rounded-xl text-label font-black ${!mes ? 'bg-ink text-page' : 'bg-chip text-secondary'}`}>
                                {!mes && datosMes?.periodo ? `Período ${ddmm(datosMes.periodo.desde)} al ${ddmm(datosMes.periodo.hasta)}` : 'Período actual'}
                            </button>
                            <select value={mes} onChange={e => setMes(e.target.value)} className={control} aria-label="Ver un mes calendario">
                                <option value="">Ver un mes…</option>
                                {ultimosMeses().map(m => <option key={m.id} value={m.id}>{m.label}</option>)}
                            </select>
                        </>
                    )}
                    <MedioViaje valor={medio} onChange={setMedio} />
                    <button type="button" onClick={irAlMapa}
                        className="h-10 px-3 rounded-xl bg-chip text-ink text-label font-black inline-flex items-center gap-1.5 active:scale-95">
                        <LuMap size={14} /> Pendientes en el mapa
                    </button>
                </div>
                {error && <p className="p-3 rounded-xl bg-[var(--warning-bg)] text-[var(--warning-tx)] text-caption font-bold">{error}</p>}
                {tab === 'mes' && (datosMes ? <TabMes datos={datosMes} /> : !error && cargando)}
                {tab === 'lugares' && (datosEq ? <TabEquipos datos={datosEq} /> : cargando)}
            </div>
        </ModalShell>
    );
}
